import "../scss/main.scss";

import Home from "./Home";
import HateLine from "./HateLine";
import HateItem from "./HateItem";

if (document.body.classList.contains("home")) {
  const home = new Home();
}

const lines = document.querySelectorAll(".hate-line");
for (let i = 0; i < lines.length; i++) {
  let hateLine = new HateLine(lines[i]);
}
const hates = document.querySelectorAll(".divider-hate");
for (let i = 0; i < hates.length; i++) {
  let hateItem = new HateItem(hates[i]);
}
const pies = document.querySelectorAll(".piechart__chart");
if (pies.length > 0) {
  import("./PieChart").then(({ default: PieChart }) => {
    for (let i = 0; i < pies.length; i++) {
      new PieChart(pies[i]);
    }
  });
}
const dogAnim = document.querySelector("#botdog-anim");
if (dogAnim) {
  import("./HomeDog").then(({ default: HomeDog }) => {
    new HomeDog(dogAnim);
  });
}
const faqContent = document.querySelector(".faq-content");
if (faqContent) {
  import("./Faq").then(({ default: Faq }) => {
    new Faq(faqContent);
  });
}
const meldenLinks = document.querySelectorAll(".js-openMeldenModal");
if (meldenLinks.length > 0) {
  import("./MeldenModal").then(({ default: MeldenModal }) => {
    new MeldenModal(meldenLinks);
  });
}

const menuBtn = document.querySelector("#js-toggleMenu");
const header = document.querySelector(".header");
menuBtn.addEventListener("click", (e) => {
  e.preventDefault();
  header.classList.toggle("show-menu");
});

window.addEventListener("message", (event) => {
  if (event.origin !== window.location.origin || event.data?.type !== "pdf-viewer:resize") {
    return;
  }

  const iframe = document.querySelector(`[data-pdf-viewer-id="${event.data.id}"]`);
  const height = Number(event.data.height);

  if (!iframe || !Number.isFinite(height)) {
    return;
  }

  iframe.style.height = `${Math.max(height, 240)}px`;
});
